"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BotFighterInputComponent = void 0;
var _inputComponent = require("./input-component");
class BotFighterInputComponent extends _inputComponent.InputComponent {
  constructor() {
    super();
    this._down = true;
    this._shoot = true;
  }
  update() {
    // AI logic for fighter
  }
}
exports.BotFighterInputComponent = BotFighterInputComponent;